/* eslint-disable max-len */
import React from 'react';

const UnderlineIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="13" viewBox="0 0 10 13" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M15 16v1H5v-1h10zM7 4v6c0 1.654 1.346 3 3 3s3-1.346 3-3V4h1v6c0 2.206-1.794 4-4 4s-4-1.794-4-4V4h1z"
            transform="translate(-147.000000, -81.000000) translate(142.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default UnderlineIcon;
